<template>
  <!--
      作者 kmdshop
      时间：2020-9-25
      描述：设置-仓库设置
  -->
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <!--转让设置-->
      <div class="common-form">拍卖设置</div>
      <el-form-item label="拍卖首图" :rules="[{required: true,message: '请上传首图'}]">
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="formData.image" width="200">
        <p class="gray">*建议750X300</p>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>
  </div>
</template>

<script>

  import AuctionApi from '@/api/auction.js';
  import Upload from '@/components/file/Upload';
  export default{
    components:{
      Upload,
    },

    data(){
      return {
        /*是否正在加载*/
        loading:true,
        /*表单数据对象*/
        formData:{
          image:'',
        },
        /*是否打开图片选择*/
        isupload:false,
      }
    },
    created() {
      this.getParams();
    },
    methods:{

      /*获取配置数据*/
      getParams() {
        let self = this;
        AuctionApi.getAuction({}, true).then(res => {
            if (res.code == 1) {
              self.formData=res.data.vars.values;
              self.loading=false;
            } else {
              console.log();
            }
          })
          .catch(error => {

          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.formData;
        self.$refs.formData.validate((valid) => {
          if (valid) {
            self.loading = true;
            AuctionApi.setAuction(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你， 设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.formData.image=e[0].file_path;
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/auction/auction/setting.vue